import styled from 'styled-components';
import { Form as _Form } from 'antd';

export const Form = styled(_Form)`
  .ql-editor {
    min-height: 120px;
    max-height: 200px;
  }
`;
